import { inject } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { CanActivateFn, Router } from "@angular/router";
import { filter, map, take } from "rxjs";

import { AuthService } from "@app/shared/services/auth.service";

export const AttorneyRestrictedGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const redirect = () => router.createUrlTree(["/order/list"]);

    if(authService.userProfile()) {
        return authService.isAttorneyOnly() ? redirect() : true;
    }

    return toObservable(authService.userProfile).pipe(
        filter((profile) => profile !== null),
        take(1),
        map(() => (authService.isAttorneyOnly() ? redirect() : true)),
    );
};